export enum AddToWishlistStatus {
    ADDED = "ADDED",
    WAITING_FOR_USER_ACTION = "WAITING_FOR_USER_ACTION",
    FAILED = "FAILED",
}
